import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={30}
            height={30}
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect x={0.5} y={0.5} width={29} height={29} rx={14.5} fill="#fff" />
            <rect x={0.5} y={0.5} width={29} height={29} rx={14.5} stroke={theme["#0EA59D"]} />
            <path
                d="M20.391 19.026l.325 2.634c.084.691-.658 1.175-1.25.816l-2.883-1.716c-.2-.117-.25-.367-.142-.567a5.263 5.263 0 00.642-2.5c0-3.05-2.617-5.533-5.833-5.533-.659 0-1.3.1-1.9.3a.42.42 0 01-.534-.5c.759-3.034 3.675-5.292 7.159-5.292 4.066 0 7.358 3.075 7.358 6.867 0 2.25-1.158 4.241-2.942 5.491z"
                fill={theme["#0EA59D"]}
            />
            <path
                d="M15.833 17.694a4.05 4.05 0 01-.984 2.633c-.825 1-2.133 1.641-3.6 1.641L9.074 23.26c-.366.225-.833-.083-.783-.508l.208-1.642c-1.116-.775-1.833-2.017-1.833-3.416 0-1.467.783-2.759 1.983-3.525a4.736 4.736 0 012.6-.759c2.534 0 4.584 1.917 4.584 4.284z"
                fill={theme["#0EA59D"]}
            />
        </svg>
      )
}
  
  export default SvgComponent